export default __webpack_public_path__ + "static/media/online-training-card.049cb5cc.svg";